module.exports = __webpack_public_path__ + "static/media/404-digitalisierung.295924d1.png";